<template>
  <div class="scrollable">
    <v-container class="pa-md-6 pa-3">
      <v-row>
        <v-col>
          <v-card class="mx-auto">
            <div class="pa-4 text-center">
              <audio v-if="mediaUrl" controls>
                <source :src="mediaUrl" :type="mediaMimeType" />
                Your browser does not support the audio element.
              </audio>
            </div>
            <v-card-subtitle v-if="description.length > 0" class="pt-0 text-center">
              {{ description }}
            </v-card-subtitle>
            <v-card-text v-if="tags.length > 0" class="pt-0 text-center">
              <span v-for="(tagId, i) in tags" :key="i">
                <v-chip v-if="tagsById[tagId]" class="mr-1" small>{{ tagsById[tagId].name }}</v-chip>
              </span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import index from '../index';
import common from '@/mixins/common';
import { mapState } from 'vuex';

export default {
  name: 'AudioViewer',
  emits: [],
  mixins: [common],
  components: {},
  props: {
    container: {
      type: Object,
      default: () => {},
    },
    media: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState('media', ['tagsById']),
    mediaProperties() {
      return this.media.properties || {};
    },
    mediaFileName() {
      return this.mediaProperties?.filename;
    },
    mediaChecksum() {
      return this.mediaProperties?.checksum;
    },
    mediaMimeType() {
      return this.mediaProperties?.mimetype;
    },
    mediaUrl() {
      if (index && this.mediaFileName && this.mediaChecksum) {
        return this.moduleFileUrl(index.moduleId, this.mediaFileName, this.mediaChecksum);
      }
      return null;
    },
    properties() {
      return this.container.properties ? this.container.properties : {};
    },
    description() {
      return this.properties.description ? this.properties.description : '';
    },
    tags() {
      return this.container.tags && Array.isArray(this.container.tags) ? this.container.tags : [];
    },
  },
};
</script>
<style>
.theme-dark .article-container {
  background: #050505;
}
.theme--light .article-container {
  background: #fff;
}
.theme--dark .article {
  background: #202020;
}
.theme--light .article {
  background: #f0f0f0;
}
audio {
  display: block;
  width: 100%;
}
</style>
